"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
const useStyles = (0, _styles.makeStyles)({
  phoneNum: {
    fontWeight: 500,
    fontSize: 22,
    textDecoration: "none",
    lineHeight: 1,
    display: "block"
  }
});
var _default = useStyles;
exports.default = _default;